function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}.cls-9{clip-path:url(#clip-path-7);}.cls-10{clip-path:url(#clip-path-8);}.cls-11{clip-path:url(#clip-path-9);}.cls-12{clip-path:url(#clip-path-10);}.cls-13{clip-path:url(#clip-path-11);}.cls-14{clip-path:url(#clip-path-12);}.cls-15{clip-path:url(#clip-path-13);}.cls-16{clip-path:url(#clip-path-14);}.cls-17{clip-path:url(#clip-path-15);}.cls-18{clip-path:url(#clip-path-16);}.cls-19{clip-path:url(#clip-path-17);}.cls-20{clip-path:url(#clip-path-18);}.cls-21{clip-path:url(#clip-path-19);}.cls-22{clip-path:url(#clip-path-20);}.cls-23{clip-path:url(#clip-path-21);}.cls-24{clip-path:url(#clip-path-22);}.cls-25{clip-path:url(#clip-path-23);}.cls-26{clip-path:url(#clip-path-24);}.cls-27{clip-path:url(#clip-path-25);}.cls-28{fill:#868c90;}.cls-29{clip-path:url(#clip-path-26);}.cls-30{clip-path:url(#clip-path-27);}.cls-31{clip-path:url(#clip-path-28);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.81,66.32a3.81,3.81,0,0,0,3-1.19,5.79,5.79,0,0,0,0-6.63,3.79,3.79,0,0,0-3-1.2H26.09v9.06ZM24.14,55.53h4.64a6.74,6.74,0,0,1,3.23.76,5.31,5.31,0,0,1,2.21,2.17,7.58,7.58,0,0,1,0,6.73A5.43,5.43,0,0,1,32,67.36a6.85,6.85,0,0,1-3.23.75H24.1Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M43.28,62.6a2,2,0,0,0-.48-1.4,1.84,1.84,0,0,0-1.46-.53,2.18,2.18,0,0,0-2.28,1.93Zm-4.07,5.07A4.08,4.08,0,0,1,37.58,66a5.36,5.36,0,0,1,0-4.66,4,4,0,0,1,1.48-1.64,4.41,4.41,0,0,1,2.4-.61,3.84,3.84,0,0,1,2.81,1,3.73,3.73,0,0,1,1,2.76,5,5,0,0,1-.11,1H39A3.08,3.08,0,0,0,40,66,3.18,3.18,0,0,0,42,66.7a5.56,5.56,0,0,0,2.62-.62l.18,1.53a6.85,6.85,0,0,1-3,.68A5.2,5.2,0,0,1,39.21,67.67Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M60.34,60.09A4.4,4.4,0,0,1,61.21,63v5.1H59.32v-5a2.93,2.93,0,0,0-.44-1.8,1.76,1.76,0,0,0-1.46-.58c-1.39,0-2.09.81-2.09,2.4v5H53.45v-4.8A3.16,3.16,0,0,0,53,61.29a1.72,1.72,0,0,0-1.44-.6,2.41,2.41,0,0,0-2.09,1v6.47H47.56V59.26h1.6l.14.84a4.17,4.17,0,0,1,2.71-1,2.86,2.86,0,0,1,2.73,1.53,3.41,3.41,0,0,1,3.09-1.53A3.21,3.21,0,0,1,60.34,60.09Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.8,65.88a4,4,0,0,0,0-4.41,2.25,2.25,0,0,0-1.88-.8,2.28,2.28,0,0,0-1.89.8,3.33,3.33,0,0,0-.66,2.22,3.28,3.28,0,0,0,.66,2.2,2.33,2.33,0,0,0,1.89.82A2.3,2.3,0,0,0,69.8,65.88Zm-4.28,1.8A4,4,0,0,1,64,66a5.28,5.28,0,0,1,0-4.65,4,4,0,0,1,1.54-1.68,4.94,4.94,0,0,1,4.8,0,4.18,4.18,0,0,1,1.55,1.68,5.34,5.34,0,0,1,0,4.65,4.25,4.25,0,0,1-1.55,1.68A5,5,0,0,1,65.52,67.68Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M76.64,67.69a3.81,3.81,0,0,1-1.57-1.61,4.85,4.85,0,0,1-.54-2.39,5.25,5.25,0,0,1,.52-2.4,3.94,3.94,0,0,1,1.59-1.67,5.09,5.09,0,0,1,2.6-.61,5.27,5.27,0,0,1,2.4.54l-.22,1.58a4.72,4.72,0,0,0-2.12-.5,2.8,2.8,0,0,0-2.11.8,3.6,3.6,0,0,0,0,4.4,2.7,2.7,0,0,0,2.1.83,4.5,4.5,0,0,0,2.15-.56l.22,1.54a3.7,3.7,0,0,1-1.11.45,5.55,5.55,0,0,1-1.41.16A4.83,4.83,0,0,1,76.64,67.69Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M84.12,59.24h1.65l.12,1.2A3.32,3.32,0,0,1,88.37,59h.42l-.16,2A2.89,2.89,0,0,0,88,60.9a2.39,2.39,0,0,0-1.2.29,2,2,0,0,0-.77.66V68H84.12Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M94.54,66.56a2.57,2.57,0,0,0,.88-.69V63.78c-2.15.07-3.23.67-3.23,1.81q0,1.2,1.29,1.2a2.37,2.37,0,0,0,1-.23Zm-3.6,1a2.49,2.49,0,0,1-.74-1.88A2.4,2.4,0,0,1,91,63.82a4.87,4.87,0,0,1,2-1,10.27,10.27,0,0,1,2.4-.32,1.53,1.53,0,0,0-1.8-1.8,3.76,3.76,0,0,0-1.2.18,5.11,5.11,0,0,0-1.2.58L91,59.93a5.63,5.63,0,0,1,1.47-.63,5.75,5.75,0,0,1,1.64-.23,3,3,0,0,1,2.4.9A4.78,4.78,0,0,1,97.26,63v2.06a6,6,0,0,0,0,1,.78.78,0,0,0,.25.49,1.05,1.05,0,0,0,.6.15h.22l-.22,1.52H97.7A2.76,2.76,0,0,1,96.29,68a2,2,0,0,1-.77-.9,3.37,3.37,0,0,1-1.2.88,3.63,3.63,0,0,1-1.52.31A2.67,2.67,0,0,1,90.94,67.57Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-8",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M102.05,67.69a3.93,3.93,0,0,1-1.57-1.61,5.18,5.18,0,0,1-.52-2.39,5.24,5.24,0,0,1,.51-2.4,4,4,0,0,1,1.58-1.67,5.21,5.21,0,0,1,2.62-.61,5.27,5.27,0,0,1,2.4.54l-.22,1.58a4.75,4.75,0,0,0-2.12-.5,2.75,2.75,0,0,0-2.11.8,3.6,3.6,0,0,0,0,4.4,2.64,2.64,0,0,0,2.08.83,4.51,4.51,0,0,0,2.16-.56l.22,1.54a3.76,3.76,0,0,1-1.12.45,5.52,5.52,0,0,1-1.4.16A4.87,4.87,0,0,1,102.05,67.69Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-9",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "112.26 67.63 108.55 59.24 110.65 59.24 113.2 65.45 115.6 59.24 117.69 59.24 112.18 72.43 110.3 72.43 112.26 67.63"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-10",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "119.32 59.69 120.03 57.67 119.27 57.67 119.27 55.53 121.39 55.53 121.39 57.46 120.36 59.69 119.32 59.69"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-11",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M122.29,67.57l.19-1.73a5.17,5.17,0,0,0,1.2.65,4.48,4.48,0,0,0,1.54.25,2.28,2.28,0,0,0,1.2-.25.82.82,0,0,0,.4-.75.93.93,0,0,0-.44-.85,5.06,5.06,0,0,0-1.28-.57,11.64,11.64,0,0,1-1.42-.56,2.69,2.69,0,0,1-.92-.79,2.16,2.16,0,0,1-.36-1.3,2.41,2.41,0,0,1,.85-1.87,3.57,3.57,0,0,1,2.48-.75,5.33,5.33,0,0,1,2.56.63l-.16,1.61a5.26,5.26,0,0,0-1.1-.64,3.08,3.08,0,0,0-1.2-.22,1.88,1.88,0,0,0-1.11.26,1,1,0,0,0-.19,1.4,1.55,1.55,0,0,0,.58.4q.38.16,1.2.45a5.7,5.7,0,0,1,1.82,1,2.13,2.13,0,0,1,.67,1.69,2.41,2.41,0,0,1-.84,1.9,3.75,3.75,0,0,1-2.59.74A6.2,6.2,0,0,1,122.29,67.57Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-12",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M141.56,66.32a3.76,3.76,0,0,0,3-1.19,5.72,5.72,0,0,0,0-6.63,3.77,3.77,0,0,0-3-1.2h-2.71v9.06Zm-4.68-10.79h4.68a6.74,6.74,0,0,1,3.23.76A5.34,5.34,0,0,1,147,58.46a7.52,7.52,0,0,1,0,6.73,5.4,5.4,0,0,1-2.22,2.17,6.85,6.85,0,0,1-3.23.75h-4.68Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-13",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M154.19,66.56a2.52,2.52,0,0,0,.89-.69V63.78c-2.16.07-3.24.67-3.24,1.81,0,.8.44,1.2,1.3,1.2a2.37,2.37,0,0,0,1-.23Zm-3.59,1a2.54,2.54,0,0,1-.75-1.88,2.38,2.38,0,0,1,.82-1.87,4.87,4.87,0,0,1,2-1,10.2,10.2,0,0,1,2.4-.32,1.83,1.83,0,0,0-.45-1.4,1.93,1.93,0,0,0-1.35-.4,3.76,3.76,0,0,0-1.2.18,4.92,4.92,0,0,0-1.2.58l-.21-1.53a5.49,5.49,0,0,1,1.47-.63,5.7,5.7,0,0,1,1.64-.23,3,3,0,0,1,2.4.9,4.78,4.78,0,0,1,.76,3.06v2.06a6,6,0,0,0,0,1,.78.78,0,0,0,.25.49,1.05,1.05,0,0,0,.6.15H158l-.21,1.52h-.41a2.79,2.79,0,0,1-1.42-.29,2.08,2.08,0,0,1-.76-.9A3.37,3.37,0,0,1,154,68a3.63,3.63,0,0,1-1.52.31A2.67,2.67,0,0,1,150.6,67.57Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-14",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M161.2,67.65a2.19,2.19,0,0,1-.54-1.57V60.73h-1.42l.16-1.49h1.26V57.13l1.87-.18v2.29h2.18v1.49h-2.18v4.4a4,4,0,0,0,.1,1.19.56.56,0,0,0,.4.4,5.36,5.36,0,0,0,1.2.1h.49l-.14,1.52H163A2.19,2.19,0,0,1,161.2,67.65Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-15",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M170.85,66.56a2.28,2.28,0,0,0,.88-.69V63.78c-2.14.07-3.22.67-3.22,1.81,0,.82.42,1.2,1.28,1.2A2.28,2.28,0,0,0,170.85,66.56Zm-3.54,1a2.42,2.42,0,0,1-.74-1.88,2.3,2.3,0,0,1,.81-1.87,4.65,4.65,0,0,1,2-1,10.2,10.2,0,0,1,2.4-.32,1.91,1.91,0,0,0-.43-1.4,2,2,0,0,0-1.37-.4,4.06,4.06,0,0,0-1.2.18,5.53,5.53,0,0,0-1.2.58l-.21-1.53a5.42,5.42,0,0,1,1.46-.63,5.7,5.7,0,0,1,1.64-.23,3,3,0,0,1,2.4.9A4.77,4.77,0,0,1,173.6,63v2.06a6,6,0,0,0,.08,1,.67.67,0,0,0,.25.49,1,1,0,0,0,.6.15h.21l-.21,1.52h-.42a2.7,2.7,0,0,1-1.4-.29,1.93,1.93,0,0,1-.77-.9,3.37,3.37,0,0,1-1.2.88,3.69,3.69,0,0,1-1.54.31A2.61,2.61,0,0,1,167.31,67.57Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-16",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M182.9,65.84a3.54,3.54,0,0,0,.63-2.17,3.58,3.58,0,0,0-.63-2.17,2.05,2.05,0,0,0-1.71-.83,2.19,2.19,0,0,0-1.78.79,3.33,3.33,0,0,0-.69,2.21,3.42,3.42,0,0,0,.67,2.25,2.3,2.3,0,0,0,1.8.78A2.07,2.07,0,0,0,182.9,65.84Zm.68-6.15A4.06,4.06,0,0,1,185,61.38a5.51,5.51,0,0,1,.48,2.29,5.21,5.21,0,0,1-.51,2.33,4.11,4.11,0,0,1-1.41,1.68,3.64,3.64,0,0,1-2.07.61A4,4,0,0,1,180,68a3.55,3.55,0,0,1-1.2-.78l-.11.86h-1.7V54.63h1.87v5.46a4.07,4.07,0,0,1,1.2-.76,4,4,0,0,1,1.45-.26A3.73,3.73,0,0,1,183.58,59.69Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-17",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M191.47,66.56a2.34,2.34,0,0,0,.9-.69V63.78c-2.16.07-3.24.67-3.24,1.81q0,1.2,1.29,1.2a2.25,2.25,0,0,0,1-.23Zm-3.6,1a2.49,2.49,0,0,1-.74-1.88,2.33,2.33,0,0,1,.81-1.87,4.87,4.87,0,0,1,2-1,10.27,10.27,0,0,1,2.4-.32,1.88,1.88,0,0,0-.44-1.4,2,2,0,0,0-1.36-.4,3.8,3.8,0,0,0-1.2.18,5.11,5.11,0,0,0-1.2.58l-.21-1.53a5.63,5.63,0,0,1,1.47-.63,5.77,5.77,0,0,1,1.65-.23,2.94,2.94,0,0,1,2.39.9,4.78,4.78,0,0,1,.76,3.06v2.06a6,6,0,0,0,0,1,.71.71,0,0,0,.25.49,1,1,0,0,0,.6.15h.22L195,68.29h-.41a2.76,2.76,0,0,1-1.41-.29,2,2,0,0,1-.77-.9,3.37,3.37,0,0,1-1.2.88,3.63,3.63,0,0,1-1.52.31A2.67,2.67,0,0,1,187.87,67.57Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-18",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M197.26,67.57l.19-1.73a5,5,0,0,0,1.2.65,4.42,4.42,0,0,0,1.53.25,2.26,2.26,0,0,0,1.2-.25.81.81,0,0,0,.41-.75,1,1,0,0,0-.37-.85,5.06,5.06,0,0,0-1.28-.57,11.64,11.64,0,0,1-1.42-.56,2.6,2.6,0,0,1-.92-.79,2.16,2.16,0,0,1-.36-1.3,2.41,2.41,0,0,1,.85-1.87,3.57,3.57,0,0,1,2.48-.75,5.33,5.33,0,0,1,2.56.63l-.27,1.61a5.26,5.26,0,0,0-1.1-.64,3.08,3.08,0,0,0-1.2-.22,1.84,1.84,0,0,0-1.1.26.88.88,0,0,0-.4.79,1,1,0,0,0,.2.61,1.55,1.55,0,0,0,.58.4q.38.16,1.2.45a5.7,5.7,0,0,1,1.82,1,2.13,2.13,0,0,1,.67,1.69,2.38,2.38,0,0,1-.84,1.9,3.75,3.75,0,0,1-2.59.74A6.18,6.18,0,0,1,197.26,67.57Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-19",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M212,62.6a2,2,0,0,0-.48-1.4,1.84,1.84,0,0,0-1.46-.53,2.18,2.18,0,0,0-2.28,1.93Zm-4.07,5.07A4.08,4.08,0,0,1,206.29,66a5.33,5.33,0,0,1-.08-4.69,4,4,0,0,1,1.49-1.64A4.39,4.39,0,0,1,210,59a3.81,3.81,0,0,1,2.8,1,3.7,3.7,0,0,1,1,2.75,5.68,5.68,0,0,1-.11,1h-6.15a3.1,3.1,0,0,0,1,2.25,3.19,3.19,0,0,0,2.08.68,5.74,5.74,0,0,0,2.72-.68l.18,1.53a6.85,6.85,0,0,1-3,.68A5.21,5.21,0,0,1,207.92,67.67Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-20",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "50.07 43.88 50.07 3.12 56.21 3 56.21 43.88 50.07 43.88"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-21",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M101,32.81l4.28,3.6a19.15,19.15,0,0,1-3.18,3.49,21.41,21.41,0,0,1-5.64,3.51,19.14,19.14,0,0,1-7.86,1.5A21,21,0,0,1,77.48,42,20.1,20.1,0,0,1,70,34.07a23.52,23.52,0,0,1-2.68-11.34A24.3,24.3,0,0,1,68.82,14,22,22,0,0,1,73.2,6.81,20.36,20.36,0,0,1,80,2,21.08,21.08,0,0,1,88.72.2,20.07,20.07,0,0,1,96.5,1.58a19.17,19.17,0,0,1,5.41,3.36,21.71,21.71,0,0,1,3.36,3.74l-4.34,3.72a21.19,21.19,0,0,0-2.62-3.05,13,13,0,0,0-9.59-3.59,13.77,13.77,0,0,0-8,2.3,15.52,15.52,0,0,0-5.17,6,19.52,19.52,0,0,0-1.82,8.48A19.14,19.14,0,0,0,75.53,31a14.72,14.72,0,0,0,5.15,6,13.86,13.86,0,0,0,7.86,2.21,13.23,13.23,0,0,0,10.14-3.92C99.67,34.22,100.42,33.41,101,32.81Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-22",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.37 43.88 116.37 1.24 143.22 1.24 143.22 6.67 122.51 6.67 122.51 19.07 138.09 19.07 138.09 24.57 122.51 24.57 122.51 38.38 144.76 38.38 144.76 43.88 116.37 43.88"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-23",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M163.39,21.25h8.19a8.33,8.33,0,0,0,6-2A7.07,7.07,0,0,0,179.62,14a7,7,0,0,0-2.18-5.42,8.69,8.69,0,0,0-6-2h-8.06Zm-6,22.63V1.24H171a17.58,17.58,0,0,1,8.7,1.84,11.22,11.22,0,0,1,4.7,4.8,13.25,13.25,0,0,1,1.44,6,13.62,13.62,0,0,1-1.92,7.2,11.48,11.48,0,0,1-6,4.66l10,18.22H181L171.9,26.5h-8.57V43.88Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-24",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M216.25,39.22a14.37,14.37,0,0,0,8.12-2.31,15.54,15.54,0,0,0,5.37-6.11,18.21,18.21,0,0,0,1.92-8.39A18.6,18.6,0,0,0,229.77,14a15.28,15.28,0,0,0-5.33-6.08,14.66,14.66,0,0,0-8.19-2.27,14.41,14.41,0,0,0-8.12,2.27A15.3,15.3,0,0,0,202.79,14a18.6,18.6,0,0,0-1.89,8.39,18.5,18.5,0,0,0,1.89,8.39,15.38,15.38,0,0,0,5.34,6.11A14.34,14.34,0,0,0,216.25,39.22Zm0,5.75a21,21,0,0,1-15.48-6.56,23.36,23.36,0,0,1-4.6-7.19,22.89,22.89,0,0,1-1.66-8.73,23.28,23.28,0,0,1,1.63-8.73,21.58,21.58,0,0,1,35.61-7.19,22.37,22.37,0,0,1,4.64,7.19,22.94,22.94,0,0,1,1.67,8.73,22.65,22.65,0,0,1-6.31,15.89A21.74,21.74,0,0,1,216.25,45Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-25",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "22.58 31.06 12.11 20.61 16.2 16.53 22.58 22.91 37.47 7.94 37.38 16.19 22.58 31.06"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-26",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M33.7,32.81c-.56.6-1.31,1.41-2.27,2.4a13.86,13.86,0,0,1-3.85,2.72,14.23,14.23,0,0,1-6.27,1.2,13.78,13.78,0,0,1-7.87-2.2,14.59,14.59,0,0,1-5.14-6,18.86,18.86,0,0,1-1.82-8.39A19.24,19.24,0,0,1,8.3,14.06,15.23,15.23,0,0,1,13.48,8a13.75,13.75,0,0,1,8-2.3,13.56,13.56,0,0,1,5.66,1A13.43,13.43,0,0,1,31.05,9.3,21,21,0,0,1,33.45,12l4.08-4.09a25.25,25.25,0,0,0-2.9-2.95,19.17,19.17,0,0,0-5.41-3.36A20.15,20.15,0,0,0,21.43.2,21,21,0,0,0,12.7,2,20.42,20.42,0,0,0,5.91,6.82,22.16,22.16,0,0,0,1.54,14,24.36,24.36,0,0,0,0,22.72,23.67,23.67,0,0,0,2.69,34.06,20.06,20.06,0,0,0,10.21,42,21,21,0,0,0,21.3,44.9a19.47,19.47,0,0,0,7.86-1.5,21.35,21.35,0,0,0,5.61-3.51A19.26,19.26,0,0,0,38,36.4Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-27",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.49,5.71A13,13,0,0,1,31,9.35,20.33,20.33,0,0,1,33.44,12l4.08-4.09a25.61,25.61,0,0,0-2.89-3,19.17,19.17,0,0,0-5.41-3.36A20.15,20.15,0,0,0,21.43.2,21,21,0,0,0,12.7,2l.77,6A13.73,13.73,0,0,1,21.49,5.71Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-28",
  transform: "translate(5.99 5.99)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 12.7,
  y: 0.14,
  width: 24.82,
  height: 11.88
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 24.1,
  y: 55.53,
  width: 22.9,
  height: 24.57
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 37.04,
  y: 59.07,
  width: 20.26,
  height: 21.22
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 47.56,
  y: 59.09,
  width: 25.64,
  height: 21.06
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-6"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 63.44,
  y: 59.04,
  width: 20.96,
  height: 21.24
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 74.53,
  y: 59.01,
  width: 19.12,
  height: 21.24
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-8"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 84.12,
  y: 59.01,
  width: 16.66,
  height: 21.02
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-9"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 90.19,
  y: 59.06,
  width: 20.12,
  height: 21.22
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-10"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 99.95,
  y: 59.01,
  width: 19.11,
  height: 21.24
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-11"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 108.55,
  y: 59.24,
  width: 21.12,
  height: 25.18
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-12"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 119.27,
  y: 55.53,
  width: 14.11,
  height: 16.15
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-13"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 122.29,
  y: 59.04,
  width: 18.5,
  height: 21.21
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-14"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 136.88,
  y: 55.53,
  width: 22.91,
  height: 24.57
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-15"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 149.85,
  y: 59.06,
  width: 20.12,
  height: 21.22
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-16"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 159.24,
  y: 56.95,
  width: 17.47,
  height: 23.39
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-17"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 166.56,
  y: 59.06,
  width: 20.17,
  height: 21.23
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-18"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 176.94,
  y: 54.63,
  width: 20.49,
  height: 25.65
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-19"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 187.13,
  y: 59.06,
  width: 20.12,
  height: 21.23
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-20"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 197.26,
  y: 59.04,
  width: 18.47,
  height: 21.21
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-21"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 205.71,
  y: 59.03,
  width: 20.17,
  height: 21.25
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-22"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 50.07,
  y: 3,
  width: 18.13,
  height: 52.87
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-23"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 67.28,
  y: 0.2,
  width: 49.97,
  height: 56.71
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-24"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 116.37,
  y: 1.24,
  width: 40.38,
  height: 54.63
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-25"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 157.4,
  y: 1.22,
  width: 42.5,
  height: 54.72
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-26"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 194.51,
  width: 55.54,
  height: 56.96
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-27"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-28",
  x: 12.11,
  y: 7.94,
  width: 37.35,
  height: 35.12
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-29"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  y: 0.2,
  width: 49.96,
  height: 56.69
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-30"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-31"
}, /*#__PURE__*/React.createElement("image", {
  width: 104,
  height: 50,
  transform: "translate(18.66 6.14) scale(0.24)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAAyCAYAAACwCZ4wAAAACXBIWXMAAC4jAAAuIwF4pT92AAABiElEQVR4Xu2awW7DIBBE3ar//8dmeimSg4AdHGom9rwTawNR5mlRkPIFAJuR5TuaYNZiQeJYkDgWJI4FiWNB4liQOBYkjgWJY0HiWJA4FiSOBYljQeJYkDgWJI4FiWNB4liQOBYkjgWJY0HiWJA4FiQMgO0nmmSuB8CWUtpSShakAoAXMXlsQYvJImpyLGgR+e/wWUJNTK4t6ELKY6zXOT7iLiSS0Kot6B/J3RJJiGoLmswMKccfDhY0CTb0kXcW9CZltzDjSIyPuAnUwow6iBVoQScB+LvL6LvePAsKKI+xkaDZub11FtSADZOVUj7b950Sb0EHcrdEEkZqVm5NtAX9MVMKK6QlpVz/aEFRYGzY7LzR+pGCym5hxpGYkdB7dW3vxwjqhdCTwggcWcdIOda3FgSsubuMdF+09paCgLV3l2j+yD63EsSGEIWSx+Uz9u4Svet9/u06KHdLJGGkPhN6FHa0rvU5HytophRWCBPu2b1a448TdPZLs4G8W7P7Aq9HZm0ugO0XeexJRyItfUcAAAAASUVORK5CYII="
})))));

var SvgCiceroWhiteTagline = function SvgCiceroWhiteTagline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250.05 84.42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCiceroWhiteTagline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cicero_white_tagline.039e4058.svg";
export { ForwardRef as ReactComponent };